var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWendeDichAnUnsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 228.91,
    height: 38.43,
    viewBox: "0 0 228.91 38.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kontakt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 228.91,
    height: 38.43,
    rx: 19.22,
    ry: 19.22,
    fill: "#002d55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.31,15.5h1.27l1.29,5.47h.02l1.44-5.47h1.28l1.4,5.47h.02l1.33-5.47h1.27l-1.97,7.16h-1.27l-1.43-5.47h-.02l-1.46,5.47h-1.29l-1.88-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.48,15.5h5.15v1.08h-3.9v1.88h3.61v1.02h-3.61v2.09h3.97v1.08h-5.22v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.75,15.5h1.32l3.27,5.27h.02v-5.27h1.19v7.16h-1.32l-3.26-5.26h-.03v5.26h-1.19v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.04,15.5h2.97c2.21,0,3.16,1.6,3.16,3.58s-.95,3.58-3.16,3.58h-2.97v-7.16Zm1.25,6.14h1.23c1.96,0,2.39-1.11,2.39-2.56s-.42-2.56-2.39-2.56h-1.23v5.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.29,15.5h5.15v1.08h-3.9v1.88h3.61v1.02h-3.61v2.09h3.97v1.08h-5.22v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.4,15.5h2.97c2.21,0,3.16,1.6,3.16,3.58s-.95,3.58-3.16,3.58h-2.97v-7.16Zm1.25,6.14h1.23c1.96,0,2.39-1.11,2.39-2.56s-.42-2.56-2.39-2.56h-1.23v5.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.64,15.5h1.25v7.16h-1.25v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.27,17.78c-.21-.83-.74-1.42-1.79-1.42-1.53,0-2.17,1.35-2.17,2.73s.64,2.73,2.17,2.73c1.12,0,1.71-.83,1.83-1.87h1.22c-.11,1.71-1.31,2.9-3.05,2.9-2.13,0-3.43-1.69-3.43-3.75s1.29-3.75,3.43-3.75c1.62,0,2.88.9,3.04,2.45h-1.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.65,15.5h1.25v2.85h3.26v-2.85h1.25v7.16h-1.25v-3.23h-3.26v3.23h-1.25v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.63,15.5h1.33l2.76,7.16h-1.34l-.67-1.89h-2.86l-.67,1.89h-1.29l2.75-7.16Zm-.44,4.31h2.19l-1.07-3.08h-.03l-1.08,3.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.36,15.5h1.32l3.27,5.27h.02v-5.27h1.19v7.16h-1.32l-3.26-5.26h-.03v5.26h-1.19v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.36,15.5h1.25v4.17c0,.96.06,2.08,1.68,2.08s1.68-1.11,1.68-2.08v-4.17h1.25v4.58c0,1.83-1.17,2.75-2.94,2.75s-2.94-.91-2.94-2.75v-4.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.64,15.5h1.32l3.27,5.27h.02v-5.27h1.19v7.16h-1.32l-3.26-5.26h-.03v5.26h-1.19v-7.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.75,20.28c0,1.09.81,1.53,1.81,1.53,1.1,0,1.51-.55,1.51-1.08s-.3-.77-.59-.88c-.51-.19-1.14-.32-2.13-.59-1.23-.32-1.58-1.07-1.58-1.81,0-1.44,1.32-2.11,2.62-2.11,1.48,0,2.75.79,2.75,2.29h-1.25c-.07-.92-.67-1.26-1.54-1.26-.58,0-1.31.21-1.31.93,0,.51.34.77.85.92.11.03,1.69.44,2.06.55.93.29,1.39,1.06,1.39,1.82,0,1.6-1.43,2.25-2.85,2.25-1.63,0-2.96-.78-2.99-2.56h1.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2,16.38c-.07-3.1,1.92-5.43,5.07-5.43,2.8,0,4.77,1.65,4.77,4.52,0,1.88-.97,2.87-1.95,3.85-.97.9-1.97,1.81-1.97,3.35v.88h-1.92v-1.06c.16-3.78,3.98-3.87,3.8-7.19-.11-1.65-1.11-2.65-2.74-2.65-2.17,0-3.14,1.65-3.14,3.73h-1.92Zm3.69,8.6h2.51v2.51h-2.51v-2.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.12,34.38c-4.05,0-7.86-1.58-10.72-4.44s-4.44-6.67-4.44-10.72,1.58-7.86,4.44-10.72c2.86-2.86,6.67-4.44,10.72-4.44s7.86,1.58,10.72,4.44c2.86,2.86,4.44,6.67,4.44,10.72s-1.58,7.86-4.44,10.72-6.67,4.44-10.72,4.44Zm0-29.19c-3.75,0-7.27,1.46-9.92,4.11-2.65,2.65-4.11,6.17-4.11,9.92s1.46,7.27,4.11,9.92c2.65,2.65,6.17,4.11,9.92,4.11s7.27-1.46,9.92-4.11c2.65-2.65,4.11-6.17,4.11-9.92s-1.46-7.27-4.11-9.92c-2.65-2.65-6.17-4.11-9.92-4.11Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWendeDichAnUnsButton);
export default __webpack_public_path__ + "static/media/wende_dich_an_uns_button.1edbb264e516d446d41c197fc0ab28ad.svg";
export { ForwardRef as ReactComponent };